import React from "react";
import { CommonDialog } from "../../../../components/common/CommonDialog";
import { DialogTitle, Stack } from "@mui/material";
import { FormButtonGroup } from "../../../../components/form";
import { FormSelectCompleted } from "../../../../components/form/FormSelectCompleted";
import { useSessionContext } from "../../../../contexts/SessionContext";
import { PatchPatient } from "../../../../services/fhir/patient/PatchPatient";
import { toast } from "react-toastify";

interface IProps {
    type: "add" | "edit";
    isOpen: boolean;
    handleClose: VoidFunction;
    display: any;
    control: any;
    handleSubmit: any;
}

export function FamilyIncomeDialog({
    type,
    isOpen,
    handleClose,
    display,
    control,
    handleSubmit,
}: IProps) {
    const { userPatient, fetchUser } = useSessionContext();

    const codesFamilyIncome = [
        {
            value: "Very Low Income",
            display: "Até R$ 1.320,00 (até 1 salário mínimo)",
            code: "VLOW",
        },
        {
            value: "Low Income",
            display: "R$ 1.320,01 a R$ 2.640,00 (1 a 2 salários mínimos)",
            code: "LOW",
        },
        {
            value: "Lower Middle Income",
            display: "R$ 2.640,01 a R$ 5.280,00 (2 a 4 salários mínimos)",
            code: "LMID",
        },
        {
            value: "Middle Income",
            display: "R$ 5.280,01 a R$ 10.560,00 (4 a 8 salários mínimos)",
            code: "MID",
        },
        {
            value: "Upper Middle Income",
            display: "R$ 10.560,01 a R$ 21.120,00 (8 a 16 salários mínimos)",
            code: "UMID",
        },
        {
            value: "High Income",
            display: "Acima de R$ 21.120,00 (acima de 16 salários mínimos)",
            code: "HIGH",
        },
        {
            value: "Prefer Not to Say",
            display: "Prefiro não informar",
            code: "PNTS",
        },
    ];

    const auxDefault = codesFamilyIncome?.find(
        (el: any) => el.display === display
    );

    function verifyPath(extensionFamilyIncome: any) {
        if (extensionFamilyIncome === undefined) {
            return "/extension";
        }
        if (extensionFamilyIncome === -1) {
            return "/extension/-";
        } else {
            return `/extension/${extensionFamilyIncome}`;
        }
    }

    const auxFindExtensionFamilyIncome = userPatient?.extension?.findIndex(
        (el: any) =>
            el.url === "http://www.saude.gov.br/fhir/StructureDefinition/BRRendaFamiliar"
    );

    const onSubmit = async (data: any) => {
        const auxDisplay = codesFamilyIncome?.find(
            (el: any) => el.value === data.familyIncome?.value
        )?.display;

        const path = verifyPath(auxFindExtensionFamilyIncome);
        const content = {
            url: "http://www.saude.gov.br/fhir/StructureDefinition/BRRendaFamiliar",
            valueCodeableConcept: {
                coding: [
                    {
                        system: "http://www.saude.gov.br/fhir/CodeSystem/BRRendaFamiliar",
                        code: data?.familyIncome?.code,
                        display: auxDisplay,
                    },
                ],
            },
        };

        try {
            await PatchPatient({
                patientId: userPatient?.id,
                operation: type === "add" ? "add" : "replace",
                path,
                content:
                    auxFindExtensionFamilyIncome === undefined ? [content] : content,
            });
            await fetchUser();
            toast.success(
                `Renda familiar ${type === "add" ? "adicionada" : "atualizada"
                } com sucesso!`
            );
            handleClose();
        } catch (err) {
            console.log("err", err);
        }
    };

    return (
        <CommonDialog isOpen={isOpen} handleClose={handleClose}>
            <DialogTitle>
                {type === "add" ? "Adicionar" : "Atualizar"} Renda Familiar
                <Stack marginY={2}>
                    <FormSelectCompleted
                        defaultValue={auxDefault}
                        name="familyIncome"
                        label=""
                        control={control}
                        selectOptions={codesFamilyIncome}
                        required
                    />
                </Stack>
                <FormButtonGroup
                    goBackButtonText="Cancelar"
                    nextButtonText="Salvar"
                    onGoBackButtonClick={handleClose}
                    onNextButtonClick={handleSubmit(onSubmit)}
                />
            </DialogTitle>
        </CommonDialog>
    );
}

